<template>
  <CustumLabel
    :name="name"
    :label="label"
    :error="touched && error"
    :required="rules && rules.required"
    :hideErrors="hideErrors"
    :labelTooltip="labelTooltip"
  >
    <Input
      :value="value"
      :placeholder="placeholder"
      :type="type"
      :prefix="prefix"
      :suffix="suffix"
      :disabled="disabled"
      @change="handleChange"
      @blur="handleBlur"
    >
    </Input>
  </CustumLabel>
</template>

<script>
import validation from '@/services/validation';
import { Input } from 'ant-design-vue';
import CustumLabel from './CustumLabel.vue';

export default {
  components: { CustumLabel, Input },
  props: {
    name: String,
    label: String,
    defaultError: null,
    type: {
      type: String,
      default: 'text',
    },
    placeholder: String,
    hideErrors: Boolean,
    defaultData: String,
    labelTooltip: String,
    prefix: String,
    suffix: String,
    rules: {
      type: Object,
      default: null,
    },
    isTouched: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: null,
      error: null,
      touched: false,
      isValid: false,
    };
  },
  created() {
    if (this.defaultData) {
      this.value = this.defaultData;
      this.touched = true;
    }
    this.handleValidate();
    this.setInputValues();
  },
  watch: {
    isTouched(val) {
      if (val) {
        this.touched = true;
      }
    },
    defaultError(val) {
      if (val) {
        this.touched = true;
        this.error = val[0].length > 1 ? val[0] : val;
      }
    },
    defaultData(val) {
      if (val) {
        // this.touched = true;
        this.value = val;
        // this.touched = true;
        //  this.error = val[0].length > 1 ? val[0] : val;
      }
    },
  },
  methods: {
    handleBlur() {
      this.touched = true;
      this.handleValidate();
      this.setInputValues();
    },
    handleChange(e) {
      const val = e.target.value || null;
      this.error = null;
      this.value = val;
    },
    handleValidate() {
      const { error, isValid } = validation.validateRules(this.rules, this.value);
      this.error = error;
      this.isValid = isValid;
    },
    setInputValues() {
      const isRequired = this.rules && this.rules.required;
      if (!isRequired && !this.value) {
        return;
      }
      this.$emit('setInput', {
        [this.name]: {
          name: this.name,
          value: this.value,
          error: this.error,
          touched: this.touched,
          isValid: this.isValid,
        },
      });
    },
  },
};
</script>
